import {MYASSET_APIS} from '$constants/api-infos'
import {ConnectionInfoSuccessResponse} from '$share/types/session-io'
import {internalApi} from '$utils/api'

const {GET_SESSION_IO_CONNECTION} = MYASSET_APIS

export async function getConnectionInfo(channelName?: string) {
    const {path, method} = GET_SESSION_IO_CONNECTION
    const {data} = await internalApi<ConnectionInfoSuccessResponse>(path, {method, params: {channelName}})
    return data.result
}
